export { GetLocationsQuery } from './get-locations';
export { GetRegionsQuery } from './get-regions';
export { GetSchoolTypesQuery } from './get-school-types';
export { GetSchoolNumbersQuery } from './get-school-numbers';
